/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateEmployeePostRequestViewModel } from "../types/CreateEmployeePostRequestViewModel.ts";

export const createEmployeePostRequestViewModelSchema = z.object({
  description: z.string().nullish(),
  shortName: z.string().nullish(),
  companyId: z.number().int().nullish(),
  parentEmployeePostId: z.number().int().nullish(),
  companyDefault: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CreateEmployeePostRequestViewModel>;
